import { render, staticRenderFns } from "./MarketplaceListingsActive.vue?vue&type=template&id=5ae6d7be"
import script from "./MarketplaceListingsActive.vue?vue&type=script&lang=js"
export * from "./MarketplaceListingsActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports